export default __webpack_public_path__ + "static/media/ojos-rasgados-verde.47d3fa33.png";